import {
  Button,
  Col,
  Drawer,
  Dropdown,
  Empty,
  Form,
  Input,
  Layout,
  Menu,
  message,
  Modal,
  Popconfirm,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from 'antd'
import moment from 'moment'
import {CarryOutOutlined, EditOutlined, ExclamationCircleOutlined, FilePdfOutlined} from '@ant-design/icons'
import React, {useEffect, useImperativeHandle, useRef, useState} from 'react'
import AxiosUtil from '../../../utils/AxiosUtil'
import type {ColumnsType} from 'antd/es/table'

type IProps = {onRef: any; curEdit: any; onClose?: () => void}
type IReportItem = {
  id: number
  companyId: string
  securityCode: string
  symbol: string
  announcementId: string
  relationTable: string
  dataTable: string
  publishDate: number
  announcementTitle: string
  fileLink: string
  reportYear: string
  reportType: number
  reportProject: number
  digitalSign: number
  createTime: number
  updateTime: number
  flag: number
  memo?: any
  isVerify: number
  reportDetail: string
}
type IReportList = {total: number; list: IReportItem[]}
type IBaseInfoItem = {
  customId: string
  id: number
  dviInfoId: number
  reportYear: string
  reportDateType: number
  subId: string
  subName: string
  subValue: number
  subUnit: number
  beginDate: number
  endDate: number
  createTime: number
  updateTime: number
  flag: number
  memo?: any
  isVerify: number
}
type IAnalyseItem = {
  dviInfoId: number
  id: number
  reportType: number
  author: string
  reportYear: string
  reportDateType: number
  reportDate: number
  title: string
  summary: string
  companyId: string
  securityCode: string
  symbol: string
  exchange: string
  createTime: number
  updateTime: number
  flag: number
  memo?: any
  isVerify: number
  analysisText?: any
}
type IAnalyseList = {total: number; list: IAnalyseItem[]}
type IScoreOptions = {id: number; divName: string; enumOrder: number; enumName: string; enumValue: number}
type IScoreItem = {
  blockList: IScoreOptions[]
  id?: any
  description: string
  divName: string
  divValue?: any
  enumName?: any
  isAgg: string
  isCal: 0 | 1
  indicatorSign: number
  hinIndicatorSign: number
  children: IScoreItem[]
  enumOrder: number
  flag?: null | number
}
type IScoreOptionItem = {label: string; value: any}
type IEditScoreParams = IScoreItem & {dviBaseId: number}
type IMapData = {taskMap: {[x: string]: string}; taskTypeMap: {[x: string]: string}}

const myFlat = <T extends any[]>(arr: T): T => {
  return arr.reduce((total, cur) => total.concat(cur?.children?.length ? myFlat([...cur.children, {...cur, children: []}]) : [cur]), [])
}

const pageSize = 5
// const reportTypes: {[x: number]: string} = {1: '年度报告'}
const defaultTaskMap: {[x: number]: string} = {0: '未分配', 1: '已分配', 2: '已完成', 3: '无需处理'}
const defaultTaskTypeMap: {[x: number]: string} = {0: '分析报告', 1: '企业评价模型', 2: '数字产业化评价模型'}
const defaultMapData: IMapData = {taskMap: defaultTaskMap, taskTypeMap: defaultTaskTypeMap}
const reportProject: {[x: number]: string} = {1: '管理层讨论与分析', 2: '战略与未来模块'}
const initReportList: IReportList = {total: 0, list: []}
const subUnit: {[x: number]: string} = {1: '', 2: '元', 3: '万元', 4: '亿元', 5: '%', 6: '倍', 7: '股', 8: '万股', 9: '亿股'}
const styleRightLabel: React.CSSProperties = {lineHeight: 2, backgroundColor: '#e6f7ff', textAlign: 'center', width: 120, borderRadius: 5}
const styleTitle: React.CSSProperties = {...styleRightLabel, margin: '10px 0'}
const styleCol: React.CSSProperties = {margin: '5px 0', fontSize: 12, paddingLeft: 5}
const initAnalyseList: IAnalyseList = {total: 0, list: []}
const styleAnalyseBtnBox: React.CSSProperties = {display: 'flex', justifyContent: 'center'}
const styleAnalyseBtn: React.CSSProperties = {width: 120}
const rowGutter: [number, number] = [0, 0]
const textAlignCenter: React.CSSProperties = {textAlign: 'center'}
const styleBorder: React.CSSProperties = {border: '1px solid #d9d9d9'}
const styleRowScore: React.CSSProperties = {lineHeight: '32px', backgroundColor: '#e5e5e5', ...styleBorder}
const styleColOrder: React.CSSProperties = {textAlign: 'center', backgroundColor: 'white'}
const defaultBaseInfoSort = [
  '301',
  '302',
  '105-2',
  '105-1',
  '105-0',
  '106-2',
  '106-1',
  '106-0',
  '108',
  '109',
  '107',
  '102',
  '101',
  '103',
  '201',
  '202',
  '203',
  '204',
  '205',
  '104',
  '304',
  '305',
  '303',
]
const getBaseInfoSpan = (idx: number) => {
  const styleCol1Title: React.CSSProperties = {width: 85, padding: '0 3px'}
  const styleCol3Title: React.CSSProperties = {width: 145, padding: '0 3px'}
  const styleBaseInfoTitle: React.CSSProperties = {display: 'inline-block', border: '1px solid #c3c3c3', marginRight: 5}
  if (idx === 0) return {span: 7, style: {...styleBaseInfoTitle, ...styleCol1Title}}
  else if (idx === 1) return {span: 16, style: {...styleBaseInfoTitle, ...styleCol1Title}}
  else if ((idx - 2) % 3 === 0) return {span: 7, style: {...styleBaseInfoTitle, ...styleCol1Title}}
  else if ((idx - 2) % 3 === 1) return {span: 7, style: {...styleBaseInfoTitle, ...styleCol1Title}}
  else if ((idx - 2) % 3 === 2) return {span: 10, style: {...styleBaseInfoTitle, ...styleCol3Title}}
  else return {span: 8, style: {...styleBaseInfoTitle, ...styleCol1Title}}
}

export default function DrawerPage(props: IProps) {
  const [form] = Form.useForm() // 筛选组件中的 form
  const [showDrawer, setShowDrawer] = useState(false) // 是否显示 Drawer
  const [pageIndex, setPageIndex] = useState(1) // 当前页
  const [reportList, setReportList] = useState(initReportList) // 报告列表
  const [curReport, setCurReport] = useState({} as IReportItem) // 当前报告详情
  const [baseInfo, setBaseInfo] = useState<{[x: string]: IBaseInfoItem}>({}) // 当前任务的基础信息
  const [reportPageIndex, setReportPageIndex] = useState(1)
  const [analyseList, setAnalyseList] = useState(initAnalyseList) // 分析报告列表
  const [isEdit, setIsEdit] = useState(false) // 是否正在编辑分析报告
  const [scoreData, setScoreData] = useState<IScoreItem[]>([]) // 评分项
  const [scoreOptions, setScoreOptions] = useState<IScoreOptionItem[][]>([]) // 评分项的下拉项
  const timer = useRef(0) // 延时器
  const [leftLoading, setLeftLoading] = useState(false) // 左侧加载中标志
  const [rightLoading, setRightLoading] = useState(false) // 右侧加载中标志
  const [mapData, setMapData] = useState(defaultMapData) // 筛选条件的 map 数据
  const [curScoreItem, setCurScoreItem] = useState({} as IScoreItem) // 当前评分项
  const [baseInfoSort, setBaseInfoSort] = useState(defaultBaseInfoSort) // 左侧基础信息的显示顺序
  const [isFinishing, setIsFinishing] = useState(false)
  const [titleWidth, setTitleWidth] = useState(0)
  const [modalInfo, setModalInfo] = useState<[number, boolean]>([-1, false])
  /** 左侧 table 的 columns */
  const columns: ColumnsType<IReportItem> = [
    {title: '日期', dataIndex: 'publishDate', render: (date) => date && moment(date).format('YYYY-MM-DD')},
    {
      title: '标题',
      dataIndex: 'announcementTitle',
      render: (text, row) => <Typography.Link onClick={() => loadReportDetail(row.id)}>{text}</Typography.Link>,
    },
    {title: '报告项目', dataIndex: 'reportProject', render: (project) => reportProject[project]},
    {title: '数字化标识', dataIndex: 'digitalSign'},
    {
      title: 'PDF',
      dataIndex: 'fileLink',
      align: 'center',
      render: (link) => (
        <Typography.Link href={link} target="_blank">
          <FilePdfOutlined />
        </Typography.Link>
      ),
    },
  ]
  /** 加载左侧 table 的数据 reportList */
  const loadReportList = (pageIndex: number, dviInfoId: number, size = pageSize) => {
    setLeftLoading(true)
    const params = {pageIndex, pageSize: size, dviInfoId}
    AxiosUtil.AxiosRequest('/api/report/list', params, (suc, dat) => {
      suc && setReportList(dat)
      setLeftLoading(false)
    })
  }
  /** 加载左侧基础信息 */
  const loadBaseInfo = (dviInfoId: number) => {
    AxiosUtil.AxiosRequest('/api/report/datasubInfo', {dviInfoId}, (suc, dat: IBaseInfoItem[]) => {
      if (suc) {
        const generalIncome = dat
          .filter((item) => item.subId === '105')
          .map((item, index) => ({...item, customId: item.subId + '-' + index, subName: moment(item.beginDate).format('YYYY') + item.subName}))
        const netProfit = dat
          .filter((item) => item.subId === '106')
          .map((item, index) => ({...item, customId: item.subId + '-' + index, subName: moment(item.beginDate).format('YYYY') + item.subName}))
        const other = dat.filter((item) => !['105', '106'].includes(item.subId)).map((item) => ({...item, customId: item.subId}))
        const myData = new Map([...other, ...generalIncome, ...netProfit].map((item) => [item.customId, item]))
        const sortData = Array.from(myData)
          .map((item) => item[0])
          .sort((a, b) => {
            const indexA = defaultBaseInfoSort.findIndex((i) => i === a)
            const indexB = defaultBaseInfoSort.findIndex((i) => i === b)
            if (indexA === -1 || indexB === -1) return 1
            else return indexA - indexB
          })
        const newData = Object.fromEntries(myData)
        setBaseInfoSort(sortData)
        setBaseInfo(newData)
      }
    })
  }
  /** 获取左侧 table 中的报告详情 */
  const loadReportDetail = (reportId: number) => {
    setLeftLoading(true)
    AxiosUtil.AxiosRequest('/api/report/getInfo', {id: reportId}, (suc, dat: IReportItem) => {
      if (suc) {
        const {reportYear, reportType, companyId, securityCode, symbol, flag, memo} = dat
        const formValues = {reportYear, reportDateType: reportType, companyId, securityCode, symbol, flag, memo}
        const curFormValues = form.getFieldsValue()
        form.setFieldsValue({...curFormValues, ...formValues})
        const detail = dat.reportDetail
          ?.replace(/\r\n/g, `<br/>`)
          .replace(/\n/g, `<br/>`)
          .replace(/\r/g, `<br/>`)
          .replace(/数字化技术/g, `<span class='red'>数字化技术</span>`)
          .replace(/数字化/g, `<span class='red'>数字化</span>`)
          .replace(/数字经济/g, `<span class='red'>数字经济</span>`)
        setCurReport({...dat, reportDetail: detail})
      }
      setLeftLoading(false)
    })
  }
  /** 关闭 Drawer 的回调 */
  const onCloseDrawer = () => {
    setShowDrawer(false)
    setReportList(initReportList)
    setPageIndex(1)
    setBaseInfo({})
    setCurReport({} as IReportItem)
    setReportPageIndex(1)
    props.onClose && props.onClose()
  }
  /** 加载右侧分析报告列表 */
  const loadAnalyseList = (pageIndex: number, dviInfoId: number, size = pageSize) => {
    setRightLoading(true)
    const params = {pageIndex, pageSize: size, dviInfoId}
    AxiosUtil.AxiosRequest('/api/analysis/list', params, (suc, dat: IAnalyseList) => {
      if (suc) setAnalyseList(dat)
      setRightLoading(false)
    })
  }
  /** 获取右侧分析报告项的内容 */
  const loadAnalyseDetail = (analyseId: number) => {
    setIsEdit(true)
    AxiosUtil.AxiosRequest('/api/analysis/getInfo', {id: analyseId}, (suc, dat: IAnalyseItem) => {
      if (suc) form.setFieldsValue(dat)
      else form.resetFields()
    })
  }
  /** 编辑右侧分析报告 */
  const requestEdit = (list: IAnalyseItem[], sucCallBack = () => {}) => {
    setRightLoading(true)
    AxiosUtil.AxiosRequest('/api/analysis/editAnalysis', {list}, (suc) => {
      if (suc) sucCallBack()
      setRightLoading(false)
    })
  }
  /** 点击右侧分析报告的取消按钮 */
  const onCancle = () => {
    setIsEdit(false)
    form.resetFields()
    form.setFieldsValue(curReport)
  }
  /** 点击右侧分析报告的删除按钮 */
  const onDel = () => {
    const delItem = form.getFieldsValue()
    requestEdit([{...delItem, flag: 0}], () => {
      message.success('删除成功 !')
      onCancle()
      if (reportPageIndex === 1) loadAnalyseList(reportPageIndex, props.curEdit.dviInfoId)
      else setReportPageIndex(1)
    })
  }
  /** 保存或新增分析报告完成的回调 */
  const onAnalyseFinish = (values: any) => {
    if (curReport.id || isEdit) {
      requestEdit([values], () => {
        message.success('保存成功 !')
        onCancle()
        if (reportPageIndex === 1) loadAnalyseList(reportPageIndex, props.curEdit.dviInfoId)
        else setReportPageIndex(1)
      })
    } else message.error('当前正在新增分析报告, 请选择要分析的公告 !')
  }
  /** 获取右侧打分表所有项 */
  const loadScoreInfo = (taskType: number, dviInfoId: number) => {
    setRightLoading(true)
    AxiosUtil.AxiosRequest('/api/report/scoreInfo', {taskType, dviInfoId}, (suc, dat: IScoreItem[]) => {
      if (suc) {
        const newData = myFlat(dat)
        const options = newData.map((item) => {
          if (item.blockList?.length) return item.blockList.map((item) => ({label: item.enumName, value: item.enumOrder, score: item.enumValue}))
          else return []
        })
        const mapId = newData.map((item) => item.hinIndicatorSign)
        mapId.forEach((parentSign) => {
          const children = newData.filter((item) => item.hinIndicatorSign === parentSign)
          const total = children.reduce((tol, cur) => tol + +cur.divValue, 0)
          const parent = newData.filter((item) => item.indicatorSign === parentSign)[0]
          parent && (parent.divValue = total)
        })
        setScoreData(newData)
        setScoreOptions(options)
      }
      setRightLoading(false)
    })
  }
  /** 计算新的打分项 list */
  const mapScoreItems = (newData: IScoreItem[]) => {
    const mapId = newData.map((item) => item.hinIndicatorSign)
    mapId.forEach((parentSign) => {
      const children = newData.filter((item) => item.hinIndicatorSign === parentSign)
      const total = children.reduce((tol, cur) => tol + +cur.divValue * 100, 0)
      const parent = newData.filter((item) => item.indicatorSign === parentSign)[0]
      parent && (parent.divValue = total / 100)
    })
    return newData
  }
  /** 右侧请求编辑打分项 */
  const requestEditScore = (list: IEditScoreParams[], isClear = false) => {
    if (isClear) AxiosUtil.AxiosRequest('/api/report/editScore', {list}, () => {})
    else {
      const newList = list.filter((item) => item.divValue || item.divValue === 0).map((item) => ({...item, isCal: item.isCal || 0}))
      newList.length &&
        AxiosUtil.AxiosRequest('/api/report/editScore', {list: newList}, (suc, dat: {list: IEditScoreParams[]}) => {
          if (suc) {
            const newList = list.filter((i) => !i.id)
            if (newList.length) {
              const newData = scoreData.map((item) => {
                const data = dat.list.filter((i) => i.indicatorSign === item.indicatorSign)
                if (data.length) return data[0]
                else return item
              })
              setScoreData(newData)
            }
          }
        })
    }
  }
  /** 头部当前任务完成的回调 */
  const requestFinishTask = (taskStatus: 2 | 3) => {
    setIsFinishing(true)
    const cur = props.curEdit
    const params = {id: cur.id, dviInfoId: cur.dviInfoId, dviBaseId: cur.dviBaseId, taskType: cur.taskType, taskStatus}
    AxiosUtil.AxiosRequest('/api/digitalizeTask/finishTak', params, (suc) => {
      if (suc) {
        onCloseDrawer()
        message.success(taskStatus === 2 ? '任务已完成 !' : '"已设为"无需处理"状态"')
      } else setIsFinishing(false)
    })
  }
  const finishTask = (taskStatus: 2 | 3, taskType: number) => {
    setIsFinishing(true)
    if (taskStatus === 2 && taskType) {
      const list = scoreData.filter((item) => item.isAgg !== '0').map((i) => ({...i, dviBaseId: props.curEdit.dviBaseId, isCal: '0'}))
      AxiosUtil.AxiosRequest('/api/report/editScore', {list}, (suc) => {
        if (suc) requestFinishTask(taskStatus)
        else setIsFinishing(false)
      })
    } else requestFinishTask(taskStatus)
  }
  const onCancel = () => {
    setCurScoreItem({} as IScoreItem)
    setModalInfo([-1, false])
  }
  /** 请求 map 数据, 清理副作用 */
  useEffect(() => {
    AxiosUtil.AxiosRequest('/api/digitalizeTask/taskSelectList', {}, (suc, dat: IMapData) => suc && setMapData(dat))
    return () => {
      timer.current && window.clearTimeout(timer.current)
    }
  }, [])
  useEffect(() => {
    const ele = document.getElementById('score-right-box')!
    const re = new ResizeObserver(() => setTitleWidth(ele?.scrollWidth))
    re.disconnect() // 取消该元素上的所有监听
    if (ele) re.observe(ele) // 创建监听
  }, [])
  /** pageIndex, 任务 id 发生变化时执行 */
  useEffect(() => props.curEdit.dviInfoId && loadReportList(pageIndex, props.curEdit.dviInfoId), [pageIndex, props.curEdit.dviInfoId])
  useEffect(() => props.curEdit.dviInfoId && loadBaseInfo(props.curEdit.dviInfoId), [props.curEdit.dviInfoId])
  useEffect(() => {
    if (props.curEdit.dviInfoId) {
      if (props.curEdit.taskType) loadScoreInfo(props.curEdit.taskType, props.curEdit.dviInfoId)
      else loadAnalyseList(reportPageIndex, props.curEdit.dviInfoId)
    }
  }, [props.curEdit.dviInfoId, props.curEdit.taskType, reportPageIndex])
  /** Drawer 的 title 区域 */
  const title = (
    <div className={'dialog-title'}>
      <Space className="grey">
        <EditOutlined /> {props.curEdit.taskType ? '指标录入' : '分析报告'}：<span className="blue">{props.curEdit.id}</span> /
        <span className="blue">{props.curEdit.symbol}</span> / <span className="blue">{props.curEdit.securityName}</span> /
        <span className="normal">{props.curEdit.userName}</span> /
        {props.curEdit.taskDay ? `${moment(props.curEdit.taskDay).format('YYYY-MM-DD')} /` : ''}
        <span className={'red'}>{mapData.taskMap[props.curEdit.taskStatus]}</span> /
        <span className={'red'}>{mapData.taskTypeMap[props.curEdit.taskType]}</span>
      </Space>
      <div className={'flex-blank'} />
      <Space className={'right'}>
        <Spin size="small" spinning={isFinishing}>
          <Popconfirm
            title={`确定本次任务${props.curEdit.taskType ? '指标' : '分析报告'}已经全部完成了吗？`}
            onConfirm={() => finishTask(2, props.curEdit.taskType)}
            placement={'bottom'}
            disabled={props.curEdit.taskStatus !== 1}
            okText="确定完成"
            cancelText="再看看"
          >
            <Dropdown.Button
              key="drop"
              type="primary"
              disabled={props.curEdit.taskStatus !== 1}
              overlay={
                <Menu>
                  <Popconfirm
                    title='确定把该任务设为"无需处理"吗？'
                    onConfirm={() => requestFinishTask(3)}
                    okText="确定"
                    cancelText="再看看"
                    placement={'bottom'}
                  >
                    <Menu.Item key="ignore" icon={<ExclamationCircleOutlined />} style={{color: 'red'}}>
                      无需处理
                    </Menu.Item>
                  </Popconfirm>
                </Menu>
              }
            >
              <CarryOutOutlined /> {props.curEdit.taskType ? '指标' : '报告'}完成
            </Dropdown.Button>
          </Popconfirm>
        </Spin>
      </Space>
    </div>
  )
  const modalTitle = (
    <p>
      评分依据：
      <span className="blue">
        第 {modalInfo[0] + 1} 行 -- {curScoreItem.divName}
      </span>
    </p>
  )
  /** 通过 onRef 将该组件的成员暴露出去 */
  useImperativeHandle(props.onRef, () => ({setShowDrawer}))
  /** table 的 columns */
  const reportColumns: ColumnsType<IAnalyseItem> = [
    {title: 'ID', dataIndex: 'id', align: 'center', width: 50},
    {title: '报告日期', dataIndex: 'reportDate', render: (date) => (date ? moment(date).format('YYYY-MM-DD') : '--')},
    {title: '标题', dataIndex: 'title'},
    {title: '作者', dataIndex: 'author'},
    {
      title: '编辑',
      dataIndex: 'fileLink',
      align: 'center',
      width: 60,
      render: (_, row) => (
        <Typography.Link onClick={() => loadAnalyseDetail(row.id)}>
          <EditOutlined />
        </Typography.Link>
      ),
    },
  ]

  return (
    <Drawer
      title={title}
      forceRender={true}
      placement="right"
      width={'100%'}
      bodyStyle={{backgroundColor: '#f8f8f8'}}
      visible={showDrawer}
      onClose={onCloseDrawer}
      className="inputter_window"
    >
      <Layout.Content id="inputter_container">
        <Layout className={'inputter_layout inputter_left'}>
          <Spin spinning={leftLoading}>
            <div style={styleTitle}>最新公告</div>
            <Table
              bordered
              size={'small'}
              rowKey={'id'}
              columns={columns}
              dataSource={reportList.list}
              pagination={{pageSize, current: pageIndex, onChange: setPageIndex, total: reportList.total, hideOnSinglePage: true}}
            />
            <div style={styleTitle}>基本信息</div>
            <Row className={'inputForm'}>
              {baseInfoSort.map((key, idx) => {
                const props = getBaseInfoSpan(idx)
                return (
                  <Col style={styleCol} span={props.span} key={key}>
                    <span style={props.style}>{baseInfo[key]?.subName}:</span>
                    {baseInfo[key] ? <span>{baseInfo[key]?.subValue + subUnit[baseInfo[key]?.subUnit]}</span> : '--'}
                  </Col>
                )
              })}
            </Row>
            {curReport.id ? (
              <>
                <div style={styleTitle}>报告内容</div>
                <div className={'inputForm'} style={{minHeight: 200}} dangerouslySetInnerHTML={{__html: curReport.reportDetail}}></div>
              </>
            ) : (
              <></>
            )}
          </Spin>
        </Layout>
        <Layout className={'inputter_layout inputter_right'} style={{paddingTop: 32, marginTop: 16}}>
          <Spin spinning={rightLoading}>
            {props.curEdit.taskType === 0 ? (
              <div>
                <Table
                  bordered
                  size={'small'}
                  columns={reportColumns}
                  dataSource={analyseList.list}
                  style={{marginBottom: 15}}
                  pagination={{pageSize, current: reportPageIndex, onChange: setReportPageIndex, total: analyseList.total, hideOnSinglePage: true}}
                />
                <div className="inputForm">
                  <div style={styleAnalyseBtnBox}>
                    <Button style={styleAnalyseBtn} type={'primary'} onClick={onCancle}>
                      取消
                    </Button>
                    <Button style={{...styleAnalyseBtn, margin: '0 20px'}} type={'primary'} onClick={form.submit}>
                      {isEdit ? '保存' : '新增'}
                    </Button>
                    <Popconfirm title={'确定删除这条分析报告吗 ?'} disabled={!isEdit} onConfirm={onDel} okText="删除">
                      <Button disabled={!isEdit} style={styleAnalyseBtn} type={'primary'}>
                        删除
                      </Button>
                    </Popconfirm>
                  </div>
                  <Form form={form} layout={'vertical'} onFinish={onAnalyseFinish}>
                    <Form.Item name={'id'} hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'reportType'} hidden initialValue={2}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'author'} hidden initialValue={props.curEdit.tbUserName}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'reportYear'} hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'reportDateType'} hidden>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'reportDate'} hidden initialValue={new Date().getTime()}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'companyId'} hidden initialValue={props.curEdit.companyId}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'securityCode'} hidden initialValue={props.curEdit.securityCode}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'symbol'} hidden initialValue={props.curEdit.symbol}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'exchange'} hidden initialValue={props.curEdit.exchange}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'flag'} hidden initialValue={props.curEdit.flag}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'memo'} hidden initialValue={props.curEdit.memo}>
                      <Input />
                    </Form.Item>
                    <Form.Item name={'title'} label={<div style={styleRightLabel}>标题</div>} rules={[{required: true, message: '标题不能为空!'}]}>
                      <Input placeholder={'请输入标题 !'} autoComplete="new-password" />
                    </Form.Item>
                    <Form.Item name={'summary'} label={<div style={styleRightLabel}>摘要</div>}>
                      <Input placeholder={'请输入摘要 !'} autoComplete="new-password" />
                    </Form.Item>
                    <Form.Item
                      name={'analysisText'}
                      label={<div style={styleRightLabel}>内容</div>}
                      rules={[{required: true, message: '内容不能为空!'}]}
                    >
                      <Input.TextArea placeholder={'请输入内容 !'} autoSize={{minRows: 15}} />
                    </Form.Item>
                  </Form>
                </div>
              </div>
            ) : (
              <div id={'score-right-box'}>
                <Row gutter={rowGutter} style={{...styleRowScore, position: 'fixed', width: titleWidth, transform: 'translateY(-32px)', zIndex: 99}}>
                  <Col span={10} style={{padding: '0 5px'}}>
                    指标名称
                  </Col>
                  <Col span={2} style={textAlignCenter}>
                    行次
                  </Col>
                  <Col span={5} style={textAlignCenter}>
                    选项
                  </Col>
                  <Col span={2} style={textAlignCenter}>
                    得分
                  </Col>
                  <Col span={5} style={textAlignCenter}>
                    依据
                  </Col>
                </Row>
                {scoreData.length ? (
                  scoreData.map((item, index) => {
                    const valueBgc = props.curEdit.taskStatus !== 1 && item.isAgg === '0' ? '#f5f5f5' : item.isAgg === '0' ? 'white' : undefined
                    const desBgc = item.isCal === 1 || props.curEdit.taskStatus !== 1 || !(item.divValue || item.divValue === 0) ? '#f5f5f5' : 'white'
                    const selectBgc = item.isCal === 1 ? '#f5f5f5' : item.isAgg === '0' ? 'white' : undefined
                    const desDisabled = item.isCal === 1 || props.curEdit.taskStatus !== 1 || !(item.divValue || item.divValue === 0)
                    const getBtn = (item: IScoreItem, isEdit = true) => (
                      <Button
                        type="link"
                        disabled={isEdit ? desDisabled : !item.description}
                        onClick={() => {
                          setModalInfo([index, isEdit])
                          setCurScoreItem(item)
                        }}
                      >
                        {isEdit ? '编辑' : '查看'}
                      </Button>
                    )
                    return (
                      <Row key={item.indicatorSign} gutter={rowGutter} style={styleRowScore}>
                        <Col span={10} style={{padding: '0 5px'}}>
                          {item.divName}
                        </Col>
                        <Col span={2} style={styleColOrder}>
                          {index + 1}
                        </Col>
                        <Col span={5} style={{backgroundColor: selectBgc}} className={'right-select'}>
                          {item.isAgg === '0' ? (
                            <Select
                              placeholder={'请选择 !'}
                              allowClear
                              disabled={item.isCal === 1 || props.curEdit.taskStatus !== 1}
                              options={scoreOptions[index]}
                              defaultValue={item.enumOrder === null ? undefined : item.enumOrder}
                              onBlur={() => requestEditScore([{...item, flag: 1, dviBaseId: props.curEdit.dviBaseId}])}
                              onChange={(v, o: any) => {
                                if (v) {
                                  const myData = scoreData.map((i, idx) => (idx === index ? {...i, flag: 1, divValue: o.score, enumOrder: v} : i))
                                  const newData = mapScoreItems(myData)
                                  setScoreData(newData)
                                }
                              }}
                              onClear={() => {
                                const myData = scoreData.map((i, idx) => (idx === index ? {...i, divValue: null, flag: 0} : i))
                                const newData = mapScoreItems(myData).map((i, idx) => (idx === index ? {...i, flag: null, description: ''} : i))
                                const list = newData
                                  .filter((i, idx) => idx === index && i.id)
                                  .map((i) => ({...i, flag: 0, dviBaseId: props.curEdit.dviBaseId}))
                                list.length && requestEditScore(list, true)
                                setScoreData(newData)
                              }}
                            />
                          ) : (
                            ''
                          )}
                        </Col>
                        <Col span={2} style={{textAlign: 'center', backgroundColor: valueBgc}}>
                          {item.divValue}
                        </Col>
                        <Col span={3} style={{backgroundColor: desBgc}} className={'right-input'}>
                          <Popover placement={'left'} content={item.description}>
                            <div className={'text-ellipsis'}>{item.description}</div>
                          </Popover>
                        </Col>
                        <Col span={2} style={{textAlign: 'center', backgroundColor: desBgc}}>
                          {item.isCal === 1 || props.curEdit.taskStatus !== 1 ? getBtn(item, false) : getBtn(item, true)}
                        </Col>
                      </Row>
                    )
                  })
                ) : (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{backgroundColor: 'white', margin: 0, padding: '32px 0'}} />
                )}
              </div>
            )}
          </Spin>
          <Modal
            width={600}
            destroyOnClose
            title={modalTitle}
            onCancel={onCancel}
            visible={modalInfo[0] !== -1}
            style={{left: '25%', top: '20%'}}
            okButtonProps={{disabled: !modalInfo[1]}}
            onOk={() => {
              if (modalInfo[1]) {
                const indicatorSign = curScoreItem.indicatorSign
                const myData = scoreData.map((i) => (i.indicatorSign === indicatorSign ? {...i, flag: 1, description: curScoreItem.description} : i))
                setScoreData(myData)
                requestEditScore([{...myData[modalInfo[0]], dviBaseId: props.curEdit.dviBaseId}])
              }
              onCancel()
            }}
          >
            <Input.TextArea
              showCount
              maxLength={2000}
              disabled={!modalInfo[1]}
              autoSize={{minRows: 10}}
              autoComplete={'new-password'}
              placeholder={'请输入评分依据 !'}
              defaultValue={curScoreItem.description}
              onChange={(e) => {
                timer.current && window.clearTimeout(timer.current)
                timer.current = window.setTimeout(() => setCurScoreItem({...curScoreItem, description: e.target.value}), 300)
              }}
            />
          </Modal>
        </Layout>
      </Layout.Content>
    </Drawer>
  )
}
